export default 'Audit Décret Tertiaire — OPERAT 2030 | Solution Éco France';
